export const environment = {
  appId: 2,
  appName: "overlytea",
  IsProd: true,
  baseUrl: "https://dev-api.cloccthattea.com/api",
  pwaFrontendBaseUrl: "https://dev-app.cloccthattea.com",
  insizonBackendBaseUrl: "https://dev-api.insizon.com/api",
  insizonFrontendBaseUrl: "https://dev.insizon.com",
  CloccThatTeaAppId: "690fad57f61d5fd8dc487cd3"
};
